var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('department-boxes'),_c('process-boxes'),_c('data-boxes'),_c('datasubject-boxes')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }